import portal from "@/lib/portalApi";
import { useTranslation } from "react-i18next";

const d = (r) => r.data;

export const ai = {
  status: () => portal.get("/ai/status").then(d),
  forCase: (pid) => portal.get(`/ai/processes/${pid}`).then(d),
  prepare: (pid) => portal.post(`/ai/processes/${pid}/prepare`).then(d),
  toProposal: (id) => portal.post(`/ai/drafts/${id}/proposal`, {}).then(d),
  sendMessage: (id, text) => portal.post(`/ai/drafts/${id}/message`, { text }).then(d),
  addDocuments: (id, items) => portal.post(`/ai/drafts/${id}/checklist`, { items }).then(d),
  addTasks: (id, items) => portal.post(`/ai/drafts/${id}/tasks`, { items }).then(d),
  discard: (id) => portal.post(`/ai/drafts/${id}/discard`).then(d),
  knowledge: () => portal.get("/ai/knowledge").then(d),
  saveKnowledge: (dest, body) => portal.put(`/ai/knowledge/${dest}`, body).then(d),
  resetKnowledge: (dest) => portal.post(`/ai/knowledge/${dest}/reset`).then(d),
};

const TXT = {
  en: {
    title: "AI specialist", prepare: "Prepare this case", preparing: "The agent is preparing the case…", again: "Prepare again",
    none: "No AI specialist for this destination yet.", review: "Drafts — review before using. Nothing is sent automatically.",
    summary: "Summary", checklist: "Document checklist", risks: "Points of attention", proposal: "Proposed services",
    message: "Message to the customer", nextSteps: "Next steps", toProposal: "Create proposal draft (goes to admin approval)",
    addDocs: "Add missing documents to the customer's list", sendMsg: "Send this message to the customer", addTasks: "Create tasks",
    discard: "Discard", done: "Done", by: "by", received: "received", missing: "missing", check: "check",
    fallback: "The AI service did not answer; showing the rule-based draft.", provider: "Engine",
    knowledge: "AI agents", knowledgeSub: "What each destination specialist knows. Keep it current: the agents follow it.",
    notes: "How VENKA works this destination", sources: "Official sources (one per line)", programs: "Programs",
    documents: "Standard documents (one per line)", services: "Catalogue codes (comma separated)", save: "Save", reset: "Reset to starter pack",
    agentName: "Agent name", updated: "Updated", unpriced: "Set prices in the catalogue for",
  },
  pt: {
    title: "Especialista IA", prepare: "Preparar este processo", preparing: "O agente está a preparar o processo…", again: "Preparar de novo",
    none: "Ainda não há especialista IA para este destino.", review: "Rascunhos — reveja antes de usar. Nada é enviado automaticamente.",
    summary: "Resumo", checklist: "Lista de documentos", risks: "Pontos de atenção", proposal: "Serviços propostos",
    message: "Mensagem para o cliente", nextSteps: "Próximos passos", toProposal: "Criar rascunho de proposta (vai para aprovação)",
    addDocs: "Adicionar documentos em falta à lista do cliente", sendMsg: "Enviar esta mensagem ao cliente", addTasks: "Criar tarefas",
    discard: "Descartar", done: "Feito", by: "por", received: "recebido", missing: "em falta", check: "verificar",
    fallback: "O serviço de IA não respondeu; a mostrar o rascunho por regras.", provider: "Motor",
    knowledge: "Agentes IA", knowledgeSub: "O que cada especialista de destino sabe. Mantenha atualizado: os agentes seguem isto.",
    notes: "Como a VENKA trabalha este destino", sources: "Fontes oficiais (uma por linha)", programs: "Programas",
    documents: "Documentos padrão (um por linha)", services: "Códigos da tabela (separados por vírgula)", save: "Guardar", reset: "Repor pacote inicial",
    agentName: "Nome do agente", updated: "Atualizado", unpriced: "Defina preços na tabela para",
  },
  fr: {
    title: "Spécialiste IA", prepare: "Préparer ce dossier", preparing: "L'agent prépare le dossier…", again: "Préparer à nouveau",
    none: "Pas encore de spécialiste IA pour cette destination.", review: "Brouillons — à relire avant usage. Rien n'est envoyé automatiquement.",
    summary: "Résumé", checklist: "Liste des documents", risks: "Points d'attention", proposal: "Services proposés",
    message: "Message au client", nextSteps: "Prochaines étapes", toProposal: "Créer un brouillon de proposition (soumis à approbation)",
    addDocs: "Ajouter les documents manquants à la liste du client", sendMsg: "Envoyer ce message au client", addTasks: "Créer des tâches",
    discard: "Écarter", done: "Fait", by: "par", received: "reçu", missing: "manquant", check: "à vérifier",
    fallback: "Le service IA n'a pas répondu ; brouillon à base de règles affiché.", provider: "Moteur",
    knowledge: "Agents IA", knowledgeSub: "Ce que sait chaque spécialiste. Tenez-le à jour : les agents le suivent.",
    notes: "Comment VENKA traite cette destination", sources: "Sources officielles (une par ligne)", programs: "Programmes",
    documents: "Documents standard (un par ligne)", services: "Codes de la grille (séparés par des virgules)", save: "Enregistrer", reset: "Rétablir le pack de départ",
    agentName: "Nom de l'agent", updated: "Mis à jour", unpriced: "Définissez les prix dans la grille pour",
  },
};

export function useAT() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").slice(0, 2);
  const dict = TXT[lang] || TXT.en;
  return (k) => dict[k] ?? TXT.en[k] ?? k;
}
